module.exports = __webpack_public_path__ + "img/border_left_long.4227d9d9.svg";